import React from 'react';

function TableFooter({ name, width, rightAlign }) {
  const style = { width: `${width}%` };

  return (
    <div
      className={`flex ${rightAlign ? 'justify-end' : 'justify-start'} ml-4`} // If design break, remove margin
      style={style}
    >
      {name}
    </div>
  );
}

export default TableFooter;
